module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8AgMAAABHkjHhAAAAAXNSR0IArs4c6QAAAAxQTFRFAAAAUIH4UYD3UH/3Bfzu8gAAAAN0Uk5TAEnj4s6DUAAAAExJREFUKM9jYBgugHH/ExQ+0/8fKHzm/3+GLp/t/wQUPvf/Byh8/v8fBo4v/c8Bha//vwGFb///wIDyge4BhhciPQDdCwxP9PQyNAEArxyH0+ewUI0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu/statistics-a.png
// module id = ESpF
// module chunks = 1